

































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Subscription } from '@/core/ApiTypes'
import { getDateTextFromMillis } from '@/model/Helpers'

@Component
export default class SubscriptionPeriodEndComponent extends Vue {
    @Prop()
    subscription: Subscription|undefined

    getDateTextLocal(millis: number): string {
        return getDateTextFromMillis(millis)
    }
}
